module.exports = __webpack_public_path__ + "img/李志强.249aa10b.jpg";